import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector
} from '@ngrx/store';

import * as PathwayCardsState from './pathway-cards.state';
import { PathwayCard } from '@cpd-app/generated';

// RETRIEVE OCCUPATION CARDS SLICE OF STATE
export const selectPathwayCardsState =
  createFeatureSelector<PathwayCardsState.PathwayCardsState>(
    PathwayCardsState.pathwayCardsFeatureKey
  );

// RETRIEVE OCCUPATION CARDS
export const getPathwayCardsArray: MemoizedSelector<object, PathwayCard[]> =
  createSelector(selectPathwayCardsState, PathwayCardsState.selectAll);

// RETRIEVE LOADING
export const getLoading: MemoizedSelector<object, boolean> = createSelector(
  selectPathwayCardsState,
  (state) => state.loading
);
